export const messagesTypes = {
  FILL_ERROR: 'fill-error',
  POST_ERROR: 'post-error',
  STATUS_ERROR: 'status-error',
  SHARE_POSTCARD_ERROR: 'share-postcard-error',
  SET_IMAGE_STATUS_SUCCESS: 'set-image-status-success',
  SET_IMAGE_STATUS_ERROR: 'set-image-status-error'
} as const;

export type MessagesTypesT = typeof messagesTypes[keyof typeof messagesTypes];
